import React, { FC } from 'react';
import cx from 'classnames';
import CreateCommentFormContainer from '../CreateCommentForm/CreateCommentFormContainer';
import { TCommentOrigin } from '../types';

type TCommentReplyFormProps = {
  isVisible: boolean;
  handleReplyToCommentSubmit: () => void;
  articleId: string;
  commentId: string;
  onDiscardButtonClick?: () => void;
  commentOrigin: TCommentOrigin;
  parentCommentId?: string;
};

const CommentReplyForm: FC<TCommentReplyFormProps> = ({
  isVisible,
  handleReplyToCommentSubmit,
  commentId,
  articleId,
  onDiscardButtonClick,
  commentOrigin,
}) => (
  <div
    className={cx('pl-4 border-l border-r-gray-400 transition-all duration-200', {
      'mt-8 min-h-[172px]': isVisible,
    })}
  >
    <CreateCommentFormContainer
      articleId={articleId}
      commentId={commentId}
      handleReplyToCommentSubmit={handleReplyToCommentSubmit}
      showCancelButton
      isVisible={isVisible}
      onDiscardButtonClick={onDiscardButtonClick}
      commentOrigin={commentOrigin}
      autofocusWhenVisible
    />
  </div>
);

export default CommentReplyForm;
